export const addresses = {
  colorSchemes: "0x6ef6ca41e5EAe230bf481fFe99Fa231CD8E1d3d8",
  svgHelper: "0xE46199b2B205C3eb31d6e41C2c161137BEf26d06",
};
